<template>
  <div>
    <v-card class="mt-5">
      <v-card-text>
        <div v-if="!projectRfqs.length" class="text-center">
          <strong>No Sent RFQs found...</strong>
        </div>
        <div v-for="rfq in projectRfqs" :key="rfq.id">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 0" class="px-2 cursor-pointer">
              <v-row align-md="center">
                <v-col cols="12" md="8" lg="9">
                  <div class="d-flex align-center">
                    <div>
                      <v-img
                        width="80"
                        height="60"
                        :src="require(`@/assets/images/BMC.png`)"
                        contain
                      ></v-img>
                    </div>
                    <div class="ml-1">
                      <h6 class="primary--text pb-0 mb-0">
                        <strong>{{ rfq.dealer.company }}</strong>
                      </h6>
                      <div>
                        <strong>Phone: </strong>
                        <span>{{ rfq.dealer.phone }} </span>
                      </div>
                      <div>
                        <strong>Address: </strong>
                        <span v-if="rfq.dealer.address.add_line_1"
                          >{{ rfq.dealer.address.add_line_1 }},
                        </span>
                        <span v-if="rfq.dealer.address.add_line_2"
                          >{{ rfq.dealer.address.add_line_2 }},
                        </span>
                        <span v-if="rfq.dealer.address.add_line_3"
                          >{{ rfq.dealer.address.add_line_3 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4" lg="3" class="text-right text-md-left">
                  <template v-if="rfq.status === 'sent'">
                    <div class="grey--text">
                      Sent: {{ new Date(rfq.sent_on).toLocaleString() }}
                    </div>
                  </template>

                  <template v-if="rfq.status === 'bided'">
                    <div class="grey--text">
                      Bidded: {{ new Date(rfq.responsed_on).toLocaleString() }}
                    </div>
                  </template>

                  <template v-if="rfq.status === 'awarded'">
                    <div class="grey--text">
                      Awarded: {{ new Date(rfq.awareded_on).toLocaleString() }}
                    </div>
                  </template>

                  <template
                    v-if="rfq.status === 'deny' || rfq.status === 'denied'"
                  >
                    <div class="grey--text">
                      Denied: {{ new Date(rfq.responsed_on).toLocaleString() }}
                    </div>
                    <v-icon color="warning">mdi-information</v-icon>
                    <span class="pl-1">Declined to quote</span>
                  </template>

                  <template v-if="rfq.status === 'lost'">
                    <div class="grey--text">
                      Lost: {{ new Date(rfq.responsed_on).toLocaleString() }}
                    </div>
                    <v-icon color="warning">mdi-information</v-icon>
                    <span class="pl-1">Assigned to someone else</span>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import states from "@/configs/states.json";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      projectRfqs: state => state.rfq.project_rfqs
    }),
    sentRfqs() {
      if (this.projectRfqs && this.projectRfqs.length > 0) {
        return this.projectRfqs.filter(
          rfq => rfq.status === "sent" || rfq.status === "deny"
        );
      }

      // sent, bided, awarded, lost, deny.

      return [];
    }
  },
  data() {
    return {
      states,
      requestModal: false,
      sentModal: false,
      quotesModal: false,
      dealers: [
        {
          id: 1,
          name: "Black canyon window and door",
          phone: "970-252-3547",
          address: "336 East Main St. Montrose, CO 81401",
          image: "Black Canyon",
          status: "sent"
        },
        {
          id: 2,
          name: "BMC",
          phone: "435-649-8477",
          address: "1185 West Lori Lane Kamas, UT 84036",
          image: "BMC",
          status: "declined"
        }
      ]
    };
  }
};
</script>
